declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router { 
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any; 
        children?: Array<Router>;
    } 
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'
import Ajax from '../lib/ajax';

export const locking = { 
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: '' },
    component: main,
    children: [  
        { path: 'home', meta: { title: 'Dashboard' }, name: 'home', component: () => import('../views/home/home.vue') },
        { path: '/admin/users/profile', meta: { title: 'Perfil de usuario' }, name: 'profile', component: () => import("../views/admin/user/profile.vue") },
        { path: '/sales', meta: { title: 'CEM' }, name: 'sales', component: () => import("../views/cems/sale/sale.vue") },
        { path: '/extranet', meta: { title: 'Extranet' }, name: 'extranet', component: () => import("../views/extranet/document/document.vue") },
        { path: '/agreement', meta: { title: 'Seguimiento' }, name: 'agreement', component: () => import("../views/tracing/agreement/agreement.vue") },
        { path: '/workshopinfo', meta: { title: 'Info Taller' }, name: 'workshopinfo', component: () => import("../views/tracing/workshopinfo/workshopinfo.vue") },
        { path: '/security', meta: { title: 'Seguridad' }, name: 'security', component: () => import("../views/admin/security/security.vue") },
        { path: '/warranty', meta: { title: 'Garantias' }, name: 'warranty', component: () => import("../views/preferences/warranty/warranty.vue") },        
        { path: '/preferences', meta: { title: 'Preferencias' }, name: 'preferences', component: () => import("../views/preferences/configuration/configuration.vue") },
        //{ path: '/reports', meta: { title: 'Reportes' }, name: 'reports', component: () => import("../views/reports/reports.vue") },
        //{ path: '/reports/sales-sellers', meta: { title: 'Ventas por Vendedor' }, name: 'rsalessellers', component: () => import("../views/reports/sales/sales-sellers.vue") },
    ]
}
export const appRouters: Array<Router> = [];

export const dbRouters = {
    user: () => import("../views/admin/user/user.vue"),
    role: () => import("../views/admin/role/role.vue"),
    tab: () => import("../views/admin/tab/tab.vue"),
    company: () => import("../views/admin/company/company.vue"),
    dealer: () => import("../views/admin/dealer/dealer.vue"),
    
    concept: () => import("../views/casis/concept/concept.vue"),
    fee: () => import("../views/casis/fee/fee.vue"),
    capacity: () => import("../views/casis/capacity/capacity.vue"),
    figure: () => import("../views/casis/figure/figure.vue"),
    resumen: () => import("../views/casis/resumen/resumen.vue"),
    projection: () => import("../views/casis/projection/projection.vue"),

    claim: () => import("../views/customercare/claim/claim.vue"),
    deference: () => import("../views/customercare/deference/deference.vue"),
    caredash: () => import("../views/customercare/caredashboard/caredashboard.vue"),     
        
    //generaltype: () => import("../views/preferences/generaltype/generaltype.vue"),
    department: () => import("../views/preferences/department/department.vue"),
    province: () => import("../views/preferences/province/province.vue"),
    district: () => import("../views/preferences/district/district.vue"),
    //preferences: () => import("../views/preferences/configuration/configuration.vue"),
} 

export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters
];
